import { render, staticRenderFns } from "./ScrollArrows.vue?vue&type=template&id=05ea7358&scoped=true"
import script from "./ScrollArrows.vue?vue&type=script&lang=js"
export * from "./ScrollArrows.vue?vue&type=script&lang=js"
import style0 from "./ScrollArrows.vue?vue&type=style&index=0&id=05ea7358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea7358",
  null
  
)

export default component.exports